import { render, staticRenderFns } from "./CoinHealthDetail.vue?vue&type=template&id=ac84f462&scoped=true&"
import script from "./CoinHealthDetail.vue?vue&type=script&lang=js&"
export * from "./CoinHealthDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac84f462",
  null
  
)

export default component.exports